/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetFlagsTargetingSegmentPathParams = NonNullable<
  operations['internalGetFlagsTargetingSegment']['parameters']['path']
>;

export type InternalGetFlagsTargetingSegmentQueryParams = NonNullable<
  operations['internalGetFlagsTargetingSegment']['parameters']['query']
>;

export interface Input extends InternalGetFlagsTargetingSegmentPathParams {
  apiVersion?: string;
  query: InternalGetFlagsTargetingSegmentQueryParams;
}

export async function internalGetFlagsTargetingSegment(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/segments/{segmentKey}/flags', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
